module.exports = __webpack_public_path__ + "media/resume_rev/resume-rev-video-card-images-08-645b215b.jpg";